/**
 * API Endpoint Configuration
 *
 * This file determines the appropriate API endpoint URL based on the current environment.
 * - Production: enterprise.api.wealthbee.io
 * - Beta: enterprise.api.wealthbee.io (same as production)
 * - Local development: localhost:3123
 */

/**
 * Get the current API endpoint URL based on environment and user preference
 */
const getAPIEndpoint = (): string => {
  const isLocalEnvironment = window.location.href.includes("localhost");
  const useLocalApi = localStorage.getItem("useLocalApi");

  // If we're on localhost and the user has explicitly chosen to use production API
  if (isLocalEnvironment && useLocalApi === "false") {
    return "https://enterprise.api.wealthbee.io/api/v1";
  }
  // If we're on localhost and useLocalApi is unset or true
  else if (
    isLocalEnvironment &&
    (useLocalApi === null || useLocalApi === "true")
  ) {
    return "http://localhost:3123/api/v1";
  }
  // Default to production for all other environments
  else {
    return "https://enterprise.api.wealthbee.io/api/v1";
  }
};

export default getAPIEndpoint;
